import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../interfaces/user';

import { auth } from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';
import { first } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import * as firebase from 'firebase/app';
import 'firebase/auth';
import { PagesService } from './pages.service';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user$: Observable<User>;
  userData: any; // Save logged in user data
  userRef: firebase.database.Reference;
  username: string;
  uid: string;
  baseUrl: string;
  apiKey: string;

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service,
    private afAuth: AngularFireAuth,
    private db: AngularFireDatabase,
    private router: Router,
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    public pageService: PagesService,
    private http: HttpClient
  ) {
    this.baseUrl = localStorage.getItem('baseUrl');
    this.apiKey = localStorage.getItem('APIKey');

    /* Saving user data in localstorage when 
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(localStorage.getItem('user'));
      } else {
        localStorage.setItem('user', null);
        JSON.parse(localStorage.getItem('user'));
      }
    });

    this.user$ = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          // connnect to firestore
          // const userRef = db.database.ref('com_user_details/detail/')
          const userEmail = this.afAuth.auth.currentUser.email;
          // const retrievedEmail = this.db.database.ref('com_user_details/detail').child('email_to');
          
          return;
        } else {
          return of(null);
        }
      })
    );

    this.userRef = db.database.ref('/users');
   }

  async getUser() {
    return this.afAuth.authState.pipe(first()).toPromise();
  }

   // Sign in with email/password
  SignIn(email, password) {
    // firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    // .then(function() {
      firebase.auth().signInWithEmailAndPassword(email, password)
      .then((result) => {
        this.pageService.getPage('dashboard').once('value', snapshot => {
          this.ngZone.run(() => {
            this.router.navigate(['/page/' + snapshot.val().id]);
            const uid = result.user.uid;
            const name = result.user.displayName;
            localStorage.setItem('myUID', uid);
            localStorage.setItem('name', name);
            const user = firebase.database().ref(`/users/${uid}`).once('value').then(function(snapshot) {
              const loginFields = [{'password': password, 'username': snapshot.val().username, 'session_id': snapshot.val().session_id}];
              return loginFields;
            });
            return user;
          });
        });
        
        
      }).catch((error) => {
        window.alert('sign in ' + error.message);
      });
    // });
  }



  signInJoomlaUser(username, password): Observable<any> {
      const httpHeaders = new HttpHeaders({
        'Content-Type' : 'application/json',
        'Authorization': 'BASIC ' + this.apiKey
      });
      const options = {
        headers: httpHeaders
      };
      return this.http.get(`${this.baseUrl}endpoint-user?action=post&module=user&resource=login&username=${username}&password=${password}&api_key=${this.apiKey}`, options);
  }

  logoutUser(): Promise<void> {
    localStorage.setItem('user', null);
    return firebase.auth().signOut();
  }

  logoutJoomlaUser() {
    const sessionId = localStorage.getItem('session_id');
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Authorization': 'BASIC ' + this.apiKey
    });
    const options = {
      headers: httpHeaders
    };
    return this.http.get(`${this.baseUrl}/endpoint-user?module=user&action=get&resource=logout&session_id=${sessionId}&api_key=${this.apiKey}`, options);
  }

  // Profile Data
  getJoomlaUserProfile(): Observable<any> {
    const sessionId = localStorage.getItem('session_id');
    console.log('session is', sessionId);
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Authorization': 'BASIC ' + this.apiKey
    });
    const options = {
      headers: httpHeaders
    };
    return this.http.get(`${this.baseUrl}endpoint-user?module=user&action=get&resource=profile&api_key=${this.apiKey}`, options);
  }

  getUserProfile(user) {
    return this.userRef.child(`/${user}`);
  }

  getDashboard(alias) {
    this.pageService.getPage(alias).once('value', snapshot => {
      return '/page/' + snapshot.val().id;
    });
  }

  // Sign up with email/password
  SignUp(email, password, firstname, lastname, username) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign 
        up and returns promise */
        this.SendVerificationMail();
        this.setUserData(result.user.uid, email, firstname, lastname, username);
        // this.registerJoomlaUser(email, password, firstname, lastname, username);
      }).catch((error) => {
        window.alert(error.message);
      });
  }

  registerJoomlaUser(email, password, firstname, lastname, username): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Authorization': 'BASIC ' + this.apiKey
    });
    const options = {
      headers: httpHeaders
    };
    console.log('joomla register credentials', email, password, firstname, lastname, username);
    return this.http.get(`${this.baseUrl}endpoint-user?action=post&module=user&resource=register&username=${username}&password=${password}&email=${email}&firstname=${firstname}&lastname=${lastname}&api_key=${this.apiKey}`, options);
  }

  // Send email verfificaiton when new user sign up
  SendVerificationMail() {
    return this.afAuth.auth.currentUser.sendEmailVerification()
    .then(() => {
      this.router.navigate(['verify-email-address']);
    });
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail) {
    return this.afAuth.auth.sendPasswordResetEmail(passwordResetEmail)
    .then(() => {
      window.alert('Password reset email sent, check your inbox.');
    }).catch((error) => {
      window.alert(error);
    });
  }

  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return (user !== null && user.emailVerified !== false) ? true : false;
  }

  // Sign in with Google
  GoogleAuth() {
    return this.AuthLogin(new auth.GoogleAuthProvider());
  }

  // Auth logic to run auth providers
  AuthLogin(provider) {
    return this.afAuth.auth.signInWithPopup(provider)
    .then((result) => {
       this.ngZone.run(() => {
          this.router.navigate(['dashboard']);
        })
      // this.setUserData(result.user);
    }).catch((error) => {
      window.alert(error);
    });
  }

  setUserData(uid, email, firstname, lastname, username) {
    let userData = {
      email: email,
      name: firstname + ' ' + lastname,
      username: username
    };

    return firebase.database().ref(`users/${uid}`).set(userData);
  }

  // Sign out 
  SignOut() {
    return this.afAuth.auth.signOut().then(() => {
      localStorage.removeItem('user');
      this.router.navigate(['sign-in']);
    });
  }

   async googleSignin() {
    const provider = new auth.GoogleAuthProvider();
    const credential = await this.afAuth.auth.signInWithPopup(provider);
    return this.updateUserData(credential.user);
  }

  loginUser(
    email: string,
    password: string
  ): Promise<firebase.auth.UserCredential> {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  }

  private updateUserData(user) {
    // Sets user data to firestore on login
    // const userRef: AngularFirestoreDocument<User> = this.afs.doc(`users/${user.uid}`);
    const userRef = this.afAuth.auth.currentUser.uid;

    const data = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL
    };

    // return userRef.set(data, { merge: true })

  }

  async signOut() {
    await this.afAuth.auth.signOut();
    this.router.navigate(['/sign-in']);
  }
}
